import {useEffect, useState} from 'react'
import { KTSVG } from '../../../../../../_metronic/helpers'
import {useFormik} from 'formik'
import { is } from 'immutable';
import { ThemeConsumer } from 'react-bootstrap/esm/ThemeProvider';
import { Auth } from 'aws-amplify';

type Props = {
    toggleShow:any,
    isUpdate: boolean,
    itemToEdit: any,
    orgId: any
}

const OrgBranchAddModal: React.FC<Props> = ({toggleShow, isUpdate, itemToEdit, orgId}) => {
  
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formData, setFormData] = useState(isUpdate ? itemToEdit:{'id': undefined,'name':'','location':'','phone_number':'','email_address':'','status': 1});
  const [errName, setErrName] = useState(false)
  const [errPhone, setErrPhone] = useState(false)
  const [errEmail, setErrEmail] = useState(false)
  const [errLocation, setErrLocation] = useState(false)


  useEffect(() => {
    document.body.classList.add('modal-open')
    return () => {
      document.body.classList.remove('modal-open')
    }
  }, [])

  const handleSubmit = async (e : any) => {

  e.preventDefault();
  setErrName(false);
  setErrPhone(false);
  setErrEmail(false);
  setErrLocation(false);
  setIsSubmitting(true);
  try 
  {

    var errFound = false;

    if(formData.name.trim() == ''){
      errFound = true;
      setErrName(true);
    }

    if(formData.phone_number.trim() == ''){
      errFound = true;
      setErrPhone(true);
    }

    if(formData.email_address.trim() == ''){
      errFound = true;
      setErrEmail(true);
    }

    if(formData.location.trim() == ''){
      errFound = true;
      setErrLocation(true);
    }

    if(errFound){
        setIsSubmitting(false);
        return;
      }

      const auth = await Auth.currentSession();
      const token = auth.getAccessToken().getJwtToken(); 
    if(!isUpdate){
      // create process
      console.log(formData);

      const response = await fetch(process.env.REACT_APP_API_URL_BACKEND + `/organization/${orgId}/branch/create`, 
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify(formData),
      });
    }
    else
    {
      // update process
      formData["branch_id"] = formData.id; //have to add branch_id, because form input name was not affecting post value name
      
      const response = await fetch(process.env.REACT_APP_API_URL_BACKEND + '/branch/update', 
      {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify(formData),
      });
    }

    
    toggleShow();
  } 
  catch (error) 
  {
    console.log(error);
  }
};

const handleChange = (e : any) => {

  setFormData(
    {...formData, 
      [e.target.name]: e.target.value}
    );
};


  return (
    <>
      <div
        className='modal fade show d-block'
        id='kt_modal_add_user'
        role='dialog'
        tabIndex={-1}
        aria-modal='true'>
        <form id='kt_modal_add_permission_form' onSubmit={handleSubmit} className='form' noValidate>
        {/* begin::Modal dialog */}
        <div className='modal-dialog modal-dialog-centered mw-650px'>
          {/* begin::Modal content */}
          <div className='modal-content'>
            {/* <UserEditModalHeader /> */}
            <div className='modal-header'>
              {/* begin::Modal title */}
              <h2 className='fw-bold'>
              {isUpdate ? 'Update Branch' : 'Create Branch'}
              </h2>
              {/* end::Modal title */}

              {/* begin::Close */}
              <div
                className='btn btn-icon btn-sm btn-active-icon-primary'
                data-kt-users-modal-action='close'
                onClick={toggleShow}
                style={{cursor: 'pointer'}}>
                <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-1' />
              </div>
              {/* end::Close */}
            </div>

            {/* begin::Modal body */}
            <div className='modal-body scroll-y mx-5 mx-xl-15 my-7'>
              {/* <UserEditModalFormWrapper /> */}
              
              <div className='fv-row mb-7'>              
                {/* hidden field is for id if the modal is open in Update mode */}

                <input type="hidden" name="branch_id" value={formData ? formData.id: 0} onChange={handleChange}/>  
                <input type="hidden" name="organizationId" value='1'/>  
                
                <label className='required fw-semibold fs-6 mb-2'>Branch Name</label>                
                <input
                type='text'
                name='name'
                className='form-control form-control-solid mb-3 mb-lg-0'
                autoComplete='off'
                onChange={handleChange}
                value={formData ? formData.name : ''}
                />
                { errName ? <div className='form-text text-danger'>Name is required.</div> : null }
              </div>

              <div className='fv-row mb-7'>              
                {/* hidden field is for id if the modal is open in Update mode */}
                <label className='required fw-semibold fs-6 mb-2'>Branch Phone</label>                
                <input
                type='text'
                name='phone_number'
                className='form-control form-control-solid mb-3 mb-lg-0'
                autoComplete='off'
                onChange={handleChange}
                value={formData ? formData.phone_number : ''}
                />
                { errPhone ? <div className='form-text text-danger'>Phone is required.</div> : null }
              </div>

              <div className='fv-row mb-7'>              
                {/* hidden field is for id if the modal is open in Update mode */}
                <label className='required fw-semibold fs-6 mb-2'>Branch Email</label>                
                <input
                type='email'
                name='email_address'
                className='form-control form-control-solid mb-3 mb-lg-0'
                autoComplete='off'
                onChange={handleChange}
                value={formData ? formData.email_address : ''}
                />
                { errEmail ? <div className='form-text text-danger'>Email is required.</div> : null }
              </div>
              <div className='fv-row mb-7'>              
                {/* hidden field is for id if the modal is open in Update mode */}
                <label className='required fw-semibold fs-6 mb-2'>Location</label>                
                <input
                type='text'
                name='location'
                className='form-control form-control-solid mb-3 mb-lg-0'
                autoComplete='off'
                onChange={handleChange}
                value={formData ? formData.location : ''}
                />
                { errLocation ? <div className='form-text text-danger'>Location is required.</div> : null }
              </div>

              <div className='fv-row mb-7'>              
                <label className='required fw-semibold fs-6 mb-2'>Status</label>                
                <select onChange={handleChange} defaultValue={formData.status ? formData.status : 0} name='status' className='form-select form-select-solid form-select-lg fw-semibold'>
                  <option value='1' >Active</option>
                  <option value='0' >In-Active</option>
                </select>
              </div>


              <button
                type='reset'
                onClick={() => toggleShow(0)}
                className='btn btn-light me-3'
                data-kt-users-modal-action='cancel'
                disabled={isSubmitting}
              >
                Cancel
              </button>

              <button
              type='submit'
              className='btn btn-primary'
              data-kt-users-modal-action='submit'
              disabled={isSubmitting}>
              <span className='indicator-label'>{isUpdate ? 'Update' : 'Save'}</span>
              </button>
            </div>
            {/* end::Modal body */}
          </div>
          {/* end::Modal content */}
        </div>
        {/* end::Modal dialog */}
        </form>      
      </div>
      {/* begin::Modal Backdrop */}
      <div className='modal-backdrop fade show'></div>
      {/* end::Modal Backdrop */}
    </>
  )
}

export {OrgBranchAddModal}
